
interface GoogleReview {
  author_name: string;
  rating: number;
  text: string;
  profile_photo_url?: string;
  time: number;
}

export interface GoogleReviewsResponse {
  reviews: GoogleReview[];
  errorType?: string;
  errorMessage?: string;
}

export const fetchGoogleReviews = async (): Promise<GoogleReviewsResponse> => {
  try {
    const response = await fetch(
      "https://tyfcsoapssjfnbrebyok.supabase.co/functions/v1/fetch-google-reviews"
    );

    const data = await response.json();

    // Gestion des erreurs HTTP
    if (!response.ok) {
      console.error("Erreur HTTP:", response.status, data);
      return {
        reviews: [],
        errorType: data.googleStatus || "HTTP_ERROR",
        errorMessage: data.error || `Erreur: ${response.status}`
      };
    }

    // Vérification du statut Google API
    if (data.status !== "OK") {
      console.error("Erreur Google API:", data.status, data.error_message);
      return {
        reviews: [],
        errorType: data.status || "API_ERROR",
        errorMessage: data.error_message || "Erreur lors de la récupération des avis"
      };
    }

    // Vérification de la présence d'avis
    if (!data.result?.reviews || data.result.reviews.length === 0) {
      return {
        reviews: [],
        errorType: "NO_REVIEWS",
        errorMessage: "Aucun avis trouvé."
      };
    }

    // Transformation des données reçues
    const reviews = data.result.reviews.map((review: any) => ({
      author_name: review.author_name,
      rating: review.rating,
      text: review.text,
      profile_photo_url: review.profile_photo_url,
      time: review.time * 1000,
    }));

    return { reviews };
  } catch (error) {
    console.error("Erreur lors de la récupération des avis Google:", error);
    return {
      reviews: [],
      errorType: "FETCH_ERROR",
      errorMessage: error.message || "Erreur inattendue lors de la récupération des avis"
    };
  }
};

// Au lieu de retourner du JSX directement, retourne les propriétés nécessaires pour construire les étoiles
export const getStarProperties = (rating: number): { isFilled: boolean }[] => {
  return Array.from({ length: 5 }).map((_, i) => ({
    isFilled: i < rating
  }));
};
